import React, { Component } from 'react';
import { connect } from 'react-redux'
import { dismissMessage } from '../../../../actions/messages.js';

class DismissMessageButton extends Component {
  handleAlertDismiss = (messageId, e) => {
    e.preventDefault();
    this.props.dispatch(dismissMessage(messageId));
  }

  render() {
    return (
      <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={(e) => this.handleAlertDismiss(this.props.messageId, e)}>
        <span aria-hidden="true">&times;</span>
      </button>
    );
  }
}

export default connect()(DismissMessageButton);



// WEBPACK FOOTER //
// ./src/components/MessageList/components/DismissMessageButton/index.js